import {MODULE_TYPES} from "../../../constants";

export const hasModule = moduleType => {
	if (!MODULE_TYPES[moduleType]) {
		throw Error(`Unknown module of type '${moduleType}'`);
	}
	const enabledModulesJson = sessionStorage.getItem('enabledModules');
	const enabledModules = enabledModulesJson ? JSON.parse(enabledModulesJson) : [];

	if (!Array.isArray(enabledModules)) return false;

	return enabledModules.some(enabledModule => enabledModule.moduleType === moduleType);
};

export const setEnabledModules = enabledModules => {
	if (Array.isArray(enabledModules)) sessionStorage.setItem('enabledModules', JSON.stringify(enabledModules));
};

